/** Copies text; resolves false when the clipboard is not available (insecure context). */
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** The public link that joins a session: https://sing.at/ABCDE. */
export const invitationLink = (code) => `${window.location.origin}/${code}`;

/** The same link without the protocol, for display: sing.at/ABCDE. */
export const shortLink = (code) => `${window.location.host}/${code}`;

/** How long a session ran, in words: "36 minutes", "1 h 12 min". */
export const formatDuration = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.round((total % 3600) / 60);
  if (hours > 0) return `${hours} h ${minutes} min`;
  if (minutes > 0) return `${minutes} ${minutes === 1 ? "minute" : "minutes"}`;
  return `${total} s`;
};

/** Seconds as "4 min 20 s". */
export const formatSeconds = (seconds) => {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  const minutes = Math.floor(total / 60);
  const rest = total % 60;
  return minutes > 0 ? `${minutes} min ${rest} s` : `${rest} s`;
};
